export const initialErrors = {
  titleMain: String() || null,
  titleEn: String() || null,
  sortOrder: String() || null,
};

export const initialCity = {
  titleMain: String(),
  titleEn: String(),
  sortOrder: 0,
};

export type initialErrorsType = typeof initialErrors;
export type initialCityType = typeof initialCity;

export const citiesTableHead = [
  {
    id: 'titleMain',
    numeric: true,
    label: 'Title (Main)',
  },
  {
    id: 'titleEn',
    numeric: true,
    label: 'Title (English)',
  },
  {
    id: 'sortOrder',
    numeric: true,
    label: 'Sort Order',
  },
  {
    id: 'isActive',
    numeric: true,
    label: 'Status',
  },
  {
    id: 'createdAt',
    numeric: true,
    label: 'Created At',
  },
  {
    id: '',
    numeric: false,
    label: '',
  },
];

export const BAGHDAD_KARKH = [
  { label: 'Al-Mansour', value: 'Al-Mansour' },
  { label: 'Yarmouk', value: 'Yarmouk' },
  { label: 'Al-Harthia', value: 'Al-Harthia' },
  { label: 'Al-Qadsiah', value: 'Al-Qadsiah' },
  { label: 'Al-Kadhimya', value: 'Al-Kadhimya' },
  { label: 'Al-Turath', value: 'Al-Turath' },
  { label: 'Abu-Ghraib', value: 'Abu-Ghraib' },
  { label: 'Green Zone', value: 'Green Zone' },
  { label: 'Al-Salhia', value: 'Al-Salhia' },
  { label: 'Al-Alawi', value: 'Al-Alawi' },
  { label: 'Haifa Street', value: 'Haifa Street' },
  { label: 'Utafiyah', value: 'Utafiyah' },
  { label: 'Iskan', value: 'Iskan' },
  { label: 'Washash', value: 'Washash' },
  { label: 'Ali-Alsaleh', value: 'Ali-Alsaleh' },
  { label: 'Al-Adel', value: 'Al-Adel' },
  { label: "Al-Jami'a", value: "Al-Jami'a" },
  { label: 'Hay Hittin', value: 'Hay Hittin' },
  { label: 'Hurriya', value: 'Hurriya' },
  { label: "Al-A'amiriya", value: "Al-A'amiriya" },
  { label: 'Al-Khadhraa', value: 'Al-Khadhraa' },
  { label: "Al-Shu'ala", value: "Al-Shu'ala" },
  { label: 'Al-Gazaliyah', value: 'Al-Gazaliyah' },
  { label: 'Al-Dora', value: 'Al-Dora' },
  { label: 'Al-Baya', value: 'Al-Baya' },
  { label: 'Al-Alam', value: 'Al-Alam' },
  { label: 'Al-Saydiya', value: 'Al-Saydiya' },
  { label: 'Al-Jihad', value: 'Al-Jihad' },
  { label: 'Hay Al-Furat', value: 'Hay Al-Furat' },
  { label: 'Al-Shurtta', value: 'Al-Shurtta' },
  { label: 'Muwasalat', value: 'Muwasalat' },
  { label: "Hay Al-A'amel", value: "Hay Al-A'amel" },
  { label: 'Hay Al-Hussain', value: 'Hay Al-Hussain' },
  { label: 'Mahmoudiyah', value: 'Mahmoudiyah' },
  { label: 'Yusufiyah', value: 'Yusufiyah' },
  { label: 'Taji', value: 'Taji' },
  { label: 'Lutifiyah', value: 'Lutifiyah' },
  { label: 'Al-Absali Complex', value: 'Al-Absali Complex' },
  {
    label: 'Al-Ayyadi Residential Complex',
    value: 'Al-Ayyadi Residential Complex',
  },
  { label: 'Al-Mahaba City Complex', value: 'Al-Mahaba City Complex' },
  { label: 'Al-Naseem Complex', value: 'Al-Naseem Complex' },
  {
    label: 'Al-Salam Complex',
    value: 'Al-Salam Complex',
  },
  {
    label: 'Ayyadi Al-Adl Complex',
    value: 'Ayyadi Al-Adl Complex',
  },
  {
    label: 'Budoor Baghdad Complex',
    value: 'Budoor Baghdad Complex',
  },
  {
    label: 'Baghdad Star Complex',
    value: 'Baghdad Star Complex',
  },
  {
    label: 'Borouj Complex',
    value: 'Borouj Complex',
  },
  {
    label: 'Dar Al-Salam Complex',
    value: 'Dar Al-Salam Complex',
  },
  {
    label: 'Iraq Gate Complex',
    value: 'Iraq Gate Complex',
  },
  {
    label: 'Jawahir Dijla Complex',
    value: 'Jawahir Dijla Complex',
  },
  {
    label: 'Kadhimiya Gate Complex',
    value: 'Kadhimiya Gate Complex',
  },
  {
    label: 'Kadhimiya Pearl Complex',
    value: 'Kadhimiya Pearl Complex',
  },
  {
    label: 'Mansour City Complex',
    value: 'Mansour City Complex',
  },
  {
    label: 'Ocean Pearl Complex',
    value: 'Ocean Pearl Complex',
  },
  {
    label: 'Palm Complex',
    value: 'Palm Complex',
  },
  {
    label: 'Royal City Complex',
    value: 'Royal City Complex',
  },
  {
    label: 'Yamama Complex',
    value: 'Yamama Complex',
  },
];

export const BAGHDAD_RUSAFA = [
  { label: 'Karrada', value: 'Karrada' },
  { label: 'Al-Jadriyah', value: 'Al-Jadriyah' },
  { label: 'Zayouna', value: 'Zayouna' },
  { label: 'Al-Gadeer', value: 'Al-Gadeer' },
  { label: 'Adhamiyah', value: 'Adhamiyah' },
  { label: 'Al-Wazireya', value: 'Al-Wazireya' },
  { label: 'Palestine Street', value: 'Palestine Street' },
  { label: 'Al-Bnouk', value: 'Al-Bnouk' },
  { label: 'Maghrib', value: 'Maghrib' },
  { label: 'Qahira', value: 'Qahira' },
  { label: 'Sulaikh', value: 'Sulaikh' },
  { label: 'Kariyat', value: 'Kariyat' },
  { label: 'Saba Abkar', value: 'Saba Abkar' },
  { label: 'Hay Tunis', value: 'Hay Tunis' },
  { label: "Sha'ab", value: "Sha'ab" },
  { label: 'Hay Ur', value: 'Hay Ur' },
  { label: 'Sadr City', value: 'Sadr City' },
  { label: 'Al-Habibiyah', value: 'Al-Habibiyah' },
  { label: 'Camp Sarah', value: 'Camp Sarah' },
  { label: 'Al-Mashtal', value: 'Al-Mashtal' },
  { label: 'Al-Amin', value: 'Al-Amin' },
  { label: 'Al-Baladiyat', value: 'Al-Baladiyat' },
  { label: 'Baghdad Al-Jadida', value: 'Baghdad Al-Jadida' },
  { label: "Al-Sa'adoon", value: "Al-Sa'adoon" },
  { label: 'Bab Al-Moatham', value: 'Bab Al-Moatham' },
  { label: 'Kasra', value: 'Kasra' },
  { label: 'Bab Al-Sharqi', value: 'Bab Al-Sharqi' },
  { label: "Al-Za'franiya", value: "Al-Za'franiya" },
  { label: 'Kamaliya', value: 'Kamaliya' },
  { label: 'Bismayah', value: 'Bismayah' },
  { label: 'Al-Suraidat', value: 'Al-Suraidat' },
  { label: 'Al-Basateen', value: 'Al-Basateen' },
  { label: "Al-Tha'labah", value: "Al-Tha'labah" },
  { label: 'Al-Hussainya', value: 'Al-Hussainya' },
];
